function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesDressCodeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92 28c.24-8.052 3.333-13.134 4.272-14.498h5.618c.94 1.359 4.03 6.412 4.27 14.498H8.92zm6.476-19.002a.998.998 0 001.209 0l2.757-2.093-.874 4.597h-4.976l-.873-4.597 2.757 2.093zm4.985 3.258l1.432-7.535c.007-.041.002-.081.004-.121 0-.023.013-.042.013-.066V3.06a1 1 0 10-2 0v.977L16 6.946l-3.83-2.908V3.06a1 1 0 10-2 0v1.473c0 .024.013.043.015.066.002.04-.004.08.004.12l1.43 7.536C10.549 13.758 6.905 19.56 6.905 29a1 1 0 001 1h16.19a1 1 0 001-1c0-9.44-3.644-15.242-4.714-16.744z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesDressCodeFilled;